module.exports = __webpack_public_path__ + "img/zhongcanhunsudapei_image_zc.20495a74.png";